import { useEffect, useState } from 'react';

export const useIsAtPageTop = (): boolean => {
  const [isAtPageTop, setIsAtPageTop] = useState(true);

  useEffect(() => {
    if (!process.env.JS_ENV_CLIENT) return undefined;

    const readScrollPosition = (): void => setIsAtPageTop(window.scrollY <= 0);

    readScrollPosition();
    window.addEventListener('scroll', readScrollPosition, { passive: true });
    return () => window.removeEventListener('scroll', readScrollPosition);
  }, []);

  return isAtPageTop;
};

export default useIsAtPageTop;
